export enum CostIVATypeEnum {
    "Cero" = "0",
    "Five" = "5",
    "Ten" = "10",
    "TwentyOne" = "21",
    "other" = "other",
}

export class CostIVAType {
    constructor(
        public readonly id: CostIVATypeEnum,
        public readonly label: string,
    ) {}
}
